import { render, staticRenderFns } from "./createPlan.vue?vue&type=template&id=dd877ef0&scoped=true&"
import script from "./createPlan.vue?vue&type=script&lang=ts&"
export * from "./createPlan.vue?vue&type=script&lang=ts&"
import style0 from "./createPlan.vue?vue&type=style&index=0&id=dd877ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd877ef0",
  null
  
)

export default component.exports